import { render, staticRenderFns } from "./IdentifiantsFormLB.vue?vue&type=template&id=6a045d67"
import script from "./IdentifiantsFormLB.vue?vue&type=script&lang=js"
export * from "./IdentifiantsFormLB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports